import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  rootContainer: {
    position: "relative",
    margin: "0 auto",
    marginTop: 20,
    marginBottom: 20,
    width: "90%", // Adjusted width for better responsiveness
    maxWidth: "450px",
    minHeight: "140px", // Changed height to minHeight for better responsiveness
    borderRadius: 4,
    color: "black",
    backgroundColor: "white",

  },
  input: {
    margin: "0 auto",
    marginTop: 20,
    width: "90%", // Adjusted width for better responsiveness
  },
  vendorSelect: {
   
    marginTop: 20,
  },
  loader: {
    position: "absolute",
    top: "85%", // Adjusted top position for better centering
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
});

